exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-1186f5b2] .template-row{border:2px dotted black;margin:8px;padding:16px}[data-v-1186f5b2] .template-row.selected-row{border:2px dashed gray}.item-picker-column h5[data-v-1186f5b2]{position:relative;left:50%;top:50%;transform:translate(-50%, -50%)}\n", ""]);

